export default __webpack_public_path__ + "static/media/me.943b6ea6.jpg";